export default __webpack_public_path__ + "static/table_it-a5608d87c36ddc95a309491d82377475.png";